const ACCESS_KEY = 'atc.accessToken';
const REFRESH_KEY = 'atc.refreshToken';

export const getAccessToken = (): string | null => localStorage.getItem(ACCESS_KEY);

export const getRefreshToken = (): string | null => localStorage.getItem(REFRESH_KEY);

export const setTokens = (accessToken: string, refreshToken: string | null) => {
  localStorage.setItem(ACCESS_KEY, accessToken);
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
};

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
};
